/**
 * Контекст текущей сессии для слоя данных.
 *
 * Репозиториям нужен `userId`, чтобы изолировать данные аккаунтов в общей
 * локальной базе. Передавать его параметром в каждый вызов — шумно и легко
 * забыть; тянуть store аутентификации в `shared` — нарушение слоёв FSD
 * (нижний слой не должен знать о верхних).
 *
 * Поэтому здесь лежит минимальная «ячейка»: слой аутентификации кладёт в неё
 * идентификатор при входе и очищает при выходе, а слой данных только читает.
 */

let currentUserId: string | null = null;

export function setCurrentUserId(userId: string | null): void {
  currentUserId = userId;
}

export function getCurrentUserId(): string | null {
  return currentUserId;
}

/**
 * То же, но с гарантией непустого значения.
 * Вызывается репозиториями: запись без владельца — ошибка программиста,
 * и лучше упасть сразу, чем создать «осиротевшую» строку в базе.
 */
export function requireUserId(): string {
  if (!currentUserId) {
    throw new Error(
      'Нет активной сессии: операция с данными вызвана до входа пользователя. ' +
        'Убедитесь, что экран защищён гвардом маршрута.',
    );
  }
  return currentUserId;
}
